import { createContext, useContext } from 'react';

import { useEvent } from '../events/hooks/useEvent';
import { usePrerenderUserId } from '../../hooks/usePrerenderUser';
import { CfEventSubject, cfEventProperties } from './cfEventProperties';

const CfFlowEventSubjectContext = createContext<CfEventSubject | undefined>(undefined);

export const CfFlowEventSubjectProvider = CfFlowEventSubjectContext.Provider;

export const useCfFlowEventTracker = (fallback?: CfEventSubject) => {
  const { track } = useEvent();
  const subject = useContext(CfFlowEventSubjectContext) ?? fallback;
  const companyId = usePrerenderUserId();

  return (event: string, properties: Record<string, unknown> = {}) =>
    track(event, { ...properties, ...cfEventProperties(subject, companyId) });
};
